import {Injectable} from '@angular/core';
import {
  collection,
  collectionData,
  doc,
  Firestore, limit,
  orderBy,
  query,
  QueryConstraint,
  startAfter,
  where,
  writeBatch
} from "@angular/fire/firestore";
import { first } from "rxjs";
import { Notification } from "../models/notification.model";
import { TenantService } from "./tenant.service";
import { MessagesService } from "../shared/services/messages.service";
import { Timestamp } from "@firebase/firestore";

@Injectable({
  providedIn: 'root'
})
export class UserNotificationsService {

  notifications: Notification[] = [];

  constructor(private tenant: TenantService,
                  private messages: MessagesService,
                  private firestore: Firestore) {

    // this.loadNotificationsPage(0)
    //   .then(() => {
    //     console.log(`First page of notifications loaded.`)
    //   })
  }

  invalidateCache() {
    this.notifications = []
  }

  async loadNotificationsPage(pageNumber: number, userId: string,  lastPostDoc?: Timestamp) {

    try {

      if(!lastPostDoc && this.notifications.length > 0) {
        console.log("Notifications cache: ", this.notifications)

        return this.notifications
      }

      const constraints: QueryConstraint[] = [
        where("sentToUserId", "==", userId),
        orderBy("createdAt", "desc"),
      ]

      if (lastPostDoc) {

        constraints.push(startAfter(lastPostDoc));

      }

      constraints.push(limit(pageNumber))

      const userNotificationsQuery = query(collection(this.firestore, `schools/${this.tenant.id}/userNotifications`), ...constraints)

      const userNotificationsData = await collectionData(userNotificationsQuery).pipe(first()).toPromise()

      this.notifications = [...this.notifications, ...userNotificationsData as Notification[]]

      return userNotificationsData as Notification[]

    } catch (error) {
      const message = `Error loading all user notifications for userId=${userId}`;
      console.error(message, error);
      this.messages.error(message);
    }

  }

  async markAsRead(notification: Notification) {

    const batch = writeBatch(this.firestore)

    const notificationRef = doc(this.firestore, `schools/${this.tenant.id}/userNotifications/${notification.id}`);
    batch.update(notificationRef, notification);

    await batch.commit();

    this.invalidateCache()

  }

  async markAllAsRead(notifications: Notification[]) {

    const batch = writeBatch(this.firestore)

    notifications.forEach(notification => {

      const notificationRef = doc(this.firestore, `schools/${this.tenant.id}/userNotifications/${notification.id}`);
      batch.update(notificationRef, notification);

    })

    await batch.commit();

    this.invalidateCache()

  }

  async zeroOutNotificationsCounter() {

    const tenantRef = doc(this.firestore, `tenants/${this.tenant.id}`);

    const batch = writeBatch(this.firestore);
    batch.update(tenantRef, { newNotificationsCounter: 0 });

    await batch.commit();

  }

}
